import { render, staticRenderFns } from "./OndeuevMenu.vue?vue&type=template&id=44cb1f86&"
import script from "./OndeuevMenu.vue?vue&type=script&lang=js&"
export * from "./OndeuevMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports